import React from 'react';

import { CurrencyInput } from 'cpool-components/input/CurrencyInput';
import type { FieldValues } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { useApplicantInfoContext } from '~/features/leadDetails/context/ApplicantInfoContext.tsx';

type Props = {
    title: string;
    name: string;
    disabled?: boolean;
};

const TitleCurrencyInput: React.FC<Props> = ({ disabled, name, title }) => {
    const { control } = useFormContext();
    const { applicantId } = useApplicantInfoContext();

    return (
        <FormField<FieldValues, number | null> control={control} name={name}>
            {({ error, onChange, value }) => (
                <CurrencyInput
                    id={`${name}-${applicantId}`}
                    label={title}
                    labelClassName="h-8 w-[175px] shrink-0 justify-start"
                    className="w-full"
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    error={error}
                />
            )}
        </FormField>
    );
};

export default TitleCurrencyInput;
